import { getEnumKeyValuePairs } from './get-enum-key-value-pairs';

/**
 * Returns an array of keys for the specified enum type.
 * Note that it assumes the enum type has values that are either numbers or
 * strings that exactly match the keys.
 *
 * @param enumType - The enum to retrieve the keys of
 * @returns The keys of the given enum
 */
export function getEnumKeys(enumType: Record<string, any>): string[] {
    return getEnumKeyValuePairs(enumType).map(pair => pair.key);
}
